import React, { Fragment } from 'react';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';
import { parseRenderOptions } from './utils';

const buildInputProps = (props, option, index, noOptionChecked) => ({
  // Set the focusRef on the first option if no options are checked, or on the
  // checked option
  ref:
    (noOptionChecked && index === 0) || props.value === option.get('value')
      ? props.focusRef
      : null,
  disabled: !props.enabled,
  id: `${props.id}-${option.get('value')}`,
  name: props.name,
  type: 'radio',
  value: option.get('value'),
  checked: props.value === option.get('value'),
  onChange: props.onChange,
  onBlur: props.onBlur,
  onFocus: props.onFocus,
  form: props.form,
});

export const RadioField = props => {
  const renderOptions = parseRenderOptions(
    props,
    { isFloating: false },
    { wrapperClassName: 'form-group--check' },
  );

  // Check if no options are checked so we can set the focusRefon the first
  // option instead of the checked one
  const noOptionChecked = !props.options.some(
    option => props.value === option.get('value'),
  );

  return (
    <FieldWrapper {...props} renderOptions={renderOptions} fieldset>
      {!renderOptions.custom.switch ? (
        props.options.map((option, i) => (
          <div
            className={classNames('form-check', {
              'form-check-sm': renderOptions.size === 'sm',
              'form-check-inline': !renderOptions.custom.vertical,
              'is-invalid': renderOptions.hasErrors,
            })}
            key={option.get('value')}
          >
            <input
              className="form-check-input"
              {...buildInputProps(props, option, i, noOptionChecked)}
            />
            <label
              htmlFor={`${props.id}-${option.get('value')}`}
              className="form-check-label"
            >
              {option.get('label')}
            </label>
          </div>
        ))
      ) : (
        <div className="btn-group">
          {props.options.map((option, i) => (
            <Fragment key={option.get('value')}>
              <input
                className="btn-check"
                {...buildInputProps(props, option, i, noOptionChecked)}
              />
              <label
                htmlFor={`${props.id}-${option.get('value')}`}
                className={classNames('btn btn-xs', {
                  'btn-primary': props.value === option.get('value'),
                  'btn-outline-primary': props.value !== option.get('value'),
                })}
              >
                {option.get('label')}
              </label>
            </Fragment>
          ))}
        </div>
      )}
    </FieldWrapper>
  );
};
